"use client";
import { useEffect } from "react";

export default function Spotlight() {
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const root = document.documentElement;
      if (root) {
        root.style.setProperty("--mouse-x", `${e.clientX}px`);
        root.style.setProperty("--mouse-y", `${e.clientY}px`);
      }
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  return (
    /* สร้าง Layer สำหรับไฟ Spotlight */
    <div 
      className="pointer-events-none fixed inset-0 z-[9999999]"
      style={{
        background: `radial-gradient(300px circle at var(--mouse-x) var(--mouse-y), rgba(36, 158, 185, 0.15), transparent 80%)`,
        backdropFilter: 'contrast(1.2) brightness(1.2)'
      }}
    />
  );
}